export const R_HEADER_TOP_HEIGHT = 0.08
export const R_HEADER_BOT_HEIGHT = 0.015
export const R_HEADER_HEIGHT = R_HEADER_TOP_HEIGHT + R_HEADER_BOT_HEIGHT
export const R_MOBILE_HEADER_HEIGHT = 0.17

